import React from 'react';
import { FaRocket, FaUsers, FaChartLine, FaLaptop, FaHandshake, FaLightbulb, FaGlobe, FaChartBar, FaGraduationCap } from 'react-icons/fa';
import Footer from './Footer';
import Navbar from './Navbar';
import jobsData from "../data/jobsData";
import JobCard from "../components/JobCard";

const CareerPage = () => {
  return (
    <div className="bg-gray-50">
      <Navbar />
      
      {/* Hero Section */}
      <section className="relative bg-gradient-to-r from-orange-500 to-orange-600 text-white py-32 text-center overflow-hidden">
        <div className="absolute inset-0 bg-black opacity-10"></div>
        <div className="max-w-5xl mx-auto px-4 relative z-10">
          <h1 className="text-2xl md:text-4xl font-bold mb-8 leading-tight">
            Shape the Future of <br />Influencer Marketing
          </h1>
          <p className="text-base md:text-lg mb-12 max-w-3xl mx-auto">
            Join our mission to revolutionize how brands connect with influencers and transform the digital marketing landscape.
          </p>
          <div className="flex flex-col md:flex-row justify-center gap-6">
            <button className="bg-white text-orange-600 px-4 py-2 rounded-lg font-semibold text-base md:text-lg hover:bg-gray-100 transition-all transform hover:scale-105">
              Explore Opportunities
            </button>
            <button className="border-2 border-white text-white px-4 py-2 rounded-lg font-semibold text-base md:text-lg hover:bg-white hover:text-orange-600 transition-all transform hover:scale-105">
              Our Culture
            </button>
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section className="py-16 bg-white">
        <div className="max-w-5xl mx-auto px-4">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8 text-center">
            <div>
              <div className="text-xl md:text-2xl lg:text-3xl font-bold text-orange-500 mb-2">5+</div>
              <div className="text-gray-600">Global Brands</div>
            </div>
            <div>
              <div className="text-xl md:text-2xl lg:text-3xl font-bold text-orange-500 mb-2">10K+</div>
              <div className="text-gray-600">Active Influencers</div>
            </div>
            <div>
              <div className="text-xl md:text-2xl lg:text-3xl font-bold text-orange-500 mb-2">5+</div>
              <div className="text-gray-600">Countries</div>
            </div>
            <div>
              <div className="text-xl md:text-2xl lg:text-3xl font-bold text-orange-500 mb-2">100k+</div>
              <div className="text-gray-600">Monthly Reachs</div>
            </div>
          </div>
        </div>
      </section>

      {/* Mission Section */}
      <section className="py-24 px-4">
        <div className="max-w-5xl mx-auto">
          <div className="text-center mb-20">
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-gray-900 mb-8">Our Mission</h2>
            <p className="text-base md:text-lg lg:text-xl text-gray-600 max-w-4xl mx-auto leading-relaxed">
              At Infuber, we're building the future of influencer marketing by creating powerful tools that connect brands with influencers and streamline affiliate management. Our platform is transforming how businesses approach digital marketing.
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
            <div className="bg-white p-10 rounded-2xl shadow-sm hover:shadow-xl transition-all duration-300">
              <div className="text-orange-500 mb-6">
                <FaRocket className="w-16 h-16" />
              </div>
              <h3 className="text-xl md:text-2xl lg:text-3xl font-semibold mb-4">Innovation in Marketing</h3>
              <p className="text-gray-600 leading-relaxed">We're revolutionizing how brands collaborate with influencers through cutting-edge technology and data-driven insights.</p>
            </div>
            <div className="bg-white p-10 rounded-2xl shadow-sm hover:shadow-xl transition-all duration-300">
              <div className="text-orange-500 mb-6">
                <FaUsers className="w-16 h-16" />
              </div>
              <h3 className="text-xl md:text-2xl lg:text-3xl font-semibold mb-4">Community Building</h3>
              <p className="text-gray-600 leading-relaxed">Creating meaningful connections between brands and influencers to build authentic, engaging communities.</p>
            </div>
            <div className="bg-white p-10 rounded-2xl shadow-sm hover:shadow-xl transition-all duration-300">
              <div className="text-orange-500 mb-6">
                <FaChartLine className="w-16 h-16" />
              </div>
              <h3 className="text-xl md:text-2xl lg:text-3xl font-semibold mb-4">Data-Driven Growth</h3>
              <p className="text-gray-600 leading-relaxed">Leveraging analytics and insights to drive successful influencer marketing campaigns and measure real impact.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Benefits Section */}
      <section className="py-24 bg-white">
        <div className="max-w-5xl mx-auto px-4">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-center mb-20">Why Join Infuber?</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-12">
            <div className="flex items-start space-x-6">
              <div className="text-orange-500 mt-2">
                <FaLaptop className="w-8 h-8" />
              </div>
              <div>
                <h3 className="text-xl md:text-2xl lg:text-3xl font-semibold mb-4">Remote-First Culture</h3>
                <p className="text-gray-600 leading-relaxed">Work from anywhere in the world with our flexible remote work policy and global team collaboration tools.</p>
              </div>
            </div>
            <div className="flex items-start space-x-6">
              <div className="text-orange-500 mt-2">
                <FaHandshake className="w-8 h-8" />
              </div>
              <div>
                <h3 className="text-xl md:text-2xl lg:text-3xl font-semibold mb-4">Competitive Benefits</h3>
                <p className="text-gray-600 leading-relaxed">Comprehensive health insurance, flexible PTO, and competitive compensation packages that grow with you.</p>
              </div>
            </div>
            <div className="flex items-start space-x-6">
              <div className="text-orange-500 mt-2">
                <FaLightbulb className="w-8 h-8" />
              </div>
              <div>
                <h3 className="text-xl md:text-2xl lg:text-3xl font-semibold mb-4">Learning & Growth</h3>
                <p className="text-gray-600 leading-relaxed">Continuous learning opportunities through courses, certifications, and conferences to advance your career.</p>
              </div>
            </div>
            <div className="flex items-start space-x-6">
              <div className="text-orange-500 mt-2">
                <FaGlobe className="w-8 h-8" />
              </div>
              <div>
                <h3 className="text-xl md:text-2xl lg:text-3xl font-semibold mb-4">Global Impact</h3>
                <p className="text-gray-600 leading-relaxed">Work on projects that reach millions of users worldwide and make a real difference in the marketing industry.</p>
              </div>
            </div>
            <div className="flex items-start space-x-6">
              <div className="text-orange-500 mt-2">
                <FaChartBar className="w-8 h-8" />
              </div>
              <div>
                <h3 className="text-xl md:text-2xl lg:text-3xl font-semibold mb-4">Career Growth</h3>
                <p className="text-gray-600 leading-relaxed">Clear career progression paths and opportunities to take on new challenges and responsibilities.</p>
              </div>
            </div>
            <div className="flex items-start space-x-6">
              <div className="text-orange-500 mt-2">
                <FaGraduationCap className="w-8 h-8" />
              </div>
              <div>
                <h3 className="text-xl md:text-2xl lg:text-3 xl font-semibold mb-4">Professional Development</h3>
                <p className="text-gray-600 leading-relaxed">Regular training sessions, mentorship programs, and opportunities to learn from industry experts.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Open Positions Section */}
      <section className="py-24 px-4 bg-gray-50">
      <div className="max-w-5xl mx-auto">
        <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-center mb-20">
          Open Positions
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {jobsData.map((job) => (
            <JobCard key={job.id} job={job} />
          ))}
        </div>
      </div>
    </section>

      {/* Life at Infuber Section */}
      <section className="py-24 bg-white">
        <div className="max-w-5xl mx-auto px-4">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-center mb-20">Life at Infuber</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            <div className="relative rounded-2xl overflow-hidden h-80">
              <img src="https://images.unsplash.com/photo-1522071820081-009f0129c71c" alt="Team Collaboration" className="w-full h-full object-cover" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent flex items-end p-8">
                <h3 className="text-white text-xl md:text-2xl lg:text-3xl font-semibold">Team Collaboration</h3>
              </div>
            </div>
            <div className="relative rounded-2xl overflow-hidden h-80">
              <img src="https://images.unsplash.com/photo-1552664730-d307ca884978" alt="Remote Work" className="w-full h-full object-cover" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent flex items-end p-8">
                <h3 className="text-white text-xl md:text-2xl lg:text-3xl font-semibold">Remote Work</h3>
              </div>
            </div>
            <div className="relative rounded-2xl overflow-hidden h-80">
              <img src="https://images.unsplash.com/photo-1557804506-669a67965ba0" alt="Company Events" className="w-full h-full object-cover" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent flex items-end p-8">
                <h3 className="text-white text-xl md:text-2xl lg:text-3xl font-semibold">Company Events</h3>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Newsletter Section */}
      <section className="bg-gradient-to-r from-orange-500 to-orange-600 text-white py-24">
        <div className="max-w-5xl mx-auto px-4 text-center">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold mb-8">Join Our Growing Team</h2>
          <p className="text-base md:text-lg lg:text-xl mb-12 max-w-3xl mx-auto">
            Subscribe to our newsletter for the latest updates on new positions and company news.
          </p>
          <form className="flex flex-col md:flex-row gap-4 justify-center max-w-2xl mx-auto">
            <input
              type="email"
              placeholder="Enter your email"
              className="px-6 py-4 rounded-lg w-full md:w-96 text-gray-900 focus:outline-none focus:ring-2 focus:ring-white text-base md:text-lg"
            />
            <button className="bg-white text-orange-600 px-4 py-2 rounded-lg font-semibold text-base md:text-lg lg:text-xl hover:bg-gray-100 transition-all transform hover:scale-105">
              Subscribe
            </button>
          </form>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default CareerPage;
